import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import React, { useContext } from "react";
import styled from "styled-components";
import { Paper } from "../../../../../common/components/libs";
import { OrderStatus } from "../../../../../services/orders/models";
import moment from "moment";
import OrdersStoreContext from "../store/context";
import { PaymentProviderType } from "../../../../../services/general/models";
import { DeliveryType } from "../../../../../services/menu/models";
import {Trans, useTranslation} from "react-i18next";


const Wrapper = styled(Paper)`
  padding: ${
          props => {
            return props.theme.spacing(6)
          }}px;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;


const NoOrders = () => {
    const {i18n, t} = useTranslation(["general", "orders"]);
    const ordersStore = useContext(OrdersStoreContext);
    const filter = ordersStore.filter;


    const clearFilters = () => {
        ordersStore.setOrdersFilter({
            ...filter,
            createdAfter: moment().startOf("day").toDate(),
            createdBefore: moment().endOf("day").toDate(),
            isPaid: null,
            paymentTypes: [
                PaymentProviderType.cloudpayments,
                PaymentProviderType.companyInvoice,
                PaymentProviderType.offline,
                PaymentProviderType.toBankCard,
            ],
            deliveryTypes: [
                DeliveryType.toTable,
                DeliveryType.toAddress,
                DeliveryType.takeaway,
                DeliveryType.takeAwayToTime,
                DeliveryType.toVehicle,
                DeliveryType.insideTheRestaurant,
            ],
            statuses: [
                OrderStatus.accepted,
                OrderStatus.acceptedByKitchen,
                OrderStatus.canceled,
                OrderStatus.canceledWithRefund,
                OrderStatus.canceledByKitchen,
                OrderStatus.finished,
                OrderStatus.givenOut,
                OrderStatus.givenOutToDelivery,
                OrderStatus.new,
                OrderStatus.ready,
                OrderStatus.readyToPickUp,
                OrderStatus.sentToKitchen,
                OrderStatus.paid,
            ],
        });
        ordersStore.reloadOrders();
    }

    return <div style={{ maxWidth: 500, marginTop: "40px" }}>
        <Wrapper>
            <Typography component="h4" variant="body2" align="center" gutterBottom>
                {t("orders:noOrders")}
            </Typography>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                <Button variant="contained"
                        color="primary"
                        onClick={() => clearFilters()}
                >
                    {t("orders:resetFilters")}
                </Button>
            </div>
        </Wrapper>
    </div>
};


export default NoOrders
